export default __webpack_public_path__ + "static/media/Flexa.c46c8d07.jpg";